import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { useClientsStore } from '../store/clients';

export function useCurrentClient() {
  const clientStore = useClientsStore();

  const route = useRoute();

  const currentClient = computed(() => {
    return clientStore.getClientByUuid(String(route.params.clientId));
  });

  return { currentClient };
}
